import React from "react";
import { Img } from "arv-reactcomponents";
import { Header } from "arv-extends";
import { Endpoints } from "npmlinks-constants";

const { wrapper, getFinalComponent } = Header.StaticHeader;

class StaticHeader extends wrapper {
  get logoImg() {
    const { navListData } = this.props.NavListStore;
    const alt = "Wildcraft image";
    const logoFromApi =
      (navListData &&
        navListData.data &&
        navListData.data.logos &&
        navListData.data.logos.nnnow &&
        navListData.data.logos.nnnow.image) ||
      null;
    const logoUrl = logoFromApi || Endpoints.nnnowLogoUrl;

    if (logoUrl) {
      return (
        <Img className="nw-mainbar-logo is-fixed" src={logoUrl} alt={alt} />
      );
    }
    return null;
  }
}

Header.StaticHeader.component = getFinalComponent(StaticHeader);
